<template>
    <page-wrapper title="My Private Locations" :show-feed="false">

        <template slot="overlays">

          <small-modal
              title="Add Private Location"
              @close="() => show_add_location = false"
              :show-close="true"
              :show="show_add_location">
            <template slot="content">

              <div class="p-5 flex flex-wrap w-full gap-3 overflow-scroll">

                <div class="leading-loose w-full text-center">
                  <p>Private Chargabull locations are locations that can only be accessed by you.</p>
                  <p>The great thing is you have no restrictions on what content can be displayed.</p>
                  <p class="font-bold">Private locations give you complete control!</p>
                </div>

                <div class="mx-auto py-3">
                  <svg xmlns="http://www.w3.org/2000/svg"
                       class="h-40"
                       viewBox="0 0 660.47198 645.44823" xmlns:xlink="http://www.w3.org/1999/xlink"><path d="M473.90525,731.53108l.70715-15.90018a51.3526,51.3526,0,0,1,23.9526-6.06332c-11.504,9.40538-10.06637,27.53575-17.86583,40.18377a30.88872,30.88872,0,0,1-22.651,14.27412l-9.627,5.89429a51.75979,51.75979,0,0,1,10.90965-41.9429,49.9971,49.9971,0,0,1,9.18851-8.53763C470.825,725.51884,473.90525,731.53108,473.90525,731.53108Z" transform="translate(-269.76401 -127.27589)"
                                                                                                          fill="#f2f2f2"/><path d="M871.83672,499.85377c25.95488-19.769,38.35157-52.98886,30.5907-84.67859q-.28926-1.1811-.6106-2.35681c-5.14512-18.81065-17.87431-36.68854-36.42655-42.69907-15.57757-5.0467-32.58093-1.16586-48.83212-3.17276-31.90193-3.93968-56.63485-29.75207-74.03758-56.77793-17.40278-27.02593-30.7774-57.27755-53.90189-79.60489-38.117-36.80284-100.29531-44.72652-147.55489-20.77062-47.25953,23.956-77.36335,77.10423-76.07951,130.07313,1.28391,52.96891,32.72919,103.61087,78.39555,130.47968,16.776,9.87049,36.179,16.863,55.4889,14.41614,16.755-2.12308,31.97891-11.12589,48.655-13.79866,26.21872-4.20226,52.27041,7.65208,74.94762,21.466,22.67715,13.8139,44.58172,30.18754,70.35126,36.59165C817.84481,535.23941,848.8448,517.366,871.83672,499.85377Z" transform="translate(-269.76401 -127.27589)" fill="#f2f2f2"/><path d="M666.46931,263.29909h-258.57a20.36369,20.36369,0,0,0-20.34,20.34v128.69a20.36368,20.36368,0,0,0,20.34,20.34h258.57a20.35727,20.35727,0,0,0,20.34-20.34v-128.69A20.35729,20.35729,0,0,0,666.46931,263.29909Z" transform="translate(-269.76401 -127.27589)" fill="#fff"/><path d="M666.47027,433.67166H407.90387a21.36452,21.36452,0,0,1-21.34034-21.34033V283.63748a21.36452,21.36452,0,0,1,21.34034-21.34033h258.5664a21.36451,21.36451,0,0,1,21.34033,21.34033V412.33133A21.36451,21.36451,0,0,1,666.47027,433.67166ZM407.90387,264.29715a19.36254,19.36254,0,0,0-19.34034,19.34033V412.33133a19.36254,19.36254,0,0,0,19.34034,19.34033h258.5664a19.36254,19.36254,0,0,0,19.34033-19.34033V283.63748a19.36254,19.36254,0,0,0-19.34033-19.34033Z" transform="translate(-269.76401 -127.27589)" fill="#ccc"/><path d="M678.36428,469.24824H430.5757a8.07568,8.07568,0,0,1,0-16.15137H678.36428a8.07568,8.07568,0,0,1,0,16.15137Z" transform="translate(-269.76401 -127.27589)" fill="#ffcc29"/><path d="M510.01172,392.24062a8.69449,8.69449,0,0,1-4.19432-1.09245,8.58133,8.58133,0,0,1-4.50753-7.61978V311.706a8.69394,8.69394,0,0,1,13.35561-7.33865l68.13087,35.91118a8.69448,8.69448,0,0,1,0,14.6773L514.66548,390.867A8.65288,8.65288,0,0,1,510.01172,392.24062Z" transform="translate(-269.76401 -127.27589)" fill="#f2f2f2"/><path d="M910.11574,356.43244H802.0635a8.50951,8.50951,0,0,1-8.5-8.5V294.15266a8.5095,8.5095,0,0,1,8.5-8.5H910.11574a8.50949,8.50949,0,0,1,8.5,8.5v53.77978A8.5095,8.5095,0,0,1,910.11574,356.43244Z" transform="translate(-269.76401 -127.27589)" fill="#fff"/><path d="M910.11578,357.4324H802.06353a9.51081,9.51081,0,0,1-9.5-9.5V294.15262a9.51081,9.51081,0,0,1,9.5-9.5H910.11578a9.51081,9.51081,0,0,1,9.5,9.5V347.9324A9.51081,9.51081,0,0,1,910.11578,357.4324ZM802.06353,286.65262a7.5082,7.5082,0,0,0-7.5,7.5V347.9324a7.5082,7.5082,0,0,0,7.5,7.5H910.11578a7.5082,7.5082,0,0,0,7.5-7.5V294.15262a7.5082,7.5082,0,0,0-7.5-7.5Z" transform="translate(-269.76401 -127.27589)" fill="#ccc"/><path d="M892.36428,382.74836H819.5757a8.07569,8.07569,0,0,1,0-16.15137h72.78858a8.07568,8.07568,0,0,1,0,16.15137Z" transform="translate(-269.76401 -127.27589)" fill="#ffcc29"/><path d="M844.47064,340.18123a3.63334,3.63334,0,0,1-1.75276-.45652,3.586,3.586,0,0,1-1.88365-3.18423V306.52667a3.6331,3.6331,0,0,1,5.58116-3.06675l28.47118,15.00691a3.63333,3.63333,0,0,1,0,6.13349l-28.47118,15.00691A3.61592,3.61592,0,0,1,844.47064,340.18123Z" transform="translate(-269.76401 -127.27589)" fill="#d70000"/><path d="M841.11574,587.78828H733.0635a8.50982,8.50982,0,0,1-8.5-8.5V525.50849a8.50951,8.50951,0,0,1,8.5-8.5H841.11574a8.5095,8.5095,0,0,1,8.5,8.5v53.77979A8.50981,8.50981,0,0,1,841.11574,587.78828Z" transform="translate(-269.76401 -127.27589)" fill="#fff"/><path d="M841.11578,588.78836H733.06353a9.51081,9.51081,0,0,1-9.5-9.5V525.50857a9.51081,9.51081,0,0,1,9.5-9.5H841.11578a9.51081,9.51081,0,0,1,9.5,9.5v53.77979A9.51081,9.51081,0,0,1,841.11578,588.78836ZM733.06353,518.00857a7.5082,7.5082,0,0,0-7.5,7.5v53.77979a7.5082,7.5082,0,0,0,7.5,7.5H841.11578a7.5082,7.5082,0,0,0,7.5-7.5V525.50857a7.5082,7.5082,0,0,0-7.5-7.5Z" transform="translate(-269.76401 -127.27589)" fill="#ccc"/><path d="M823.36428,614.24824H750.5757a8.07569,8.07569,0,0,1,0-16.15137h72.78858a8.07568,8.07568,0,0,1,0,16.15137Z" transform="translate(-269.76401 -127.27589)" fill="#ffcc29"/><path d="M775.20794,573.18123a3.63334,3.63334,0,0,1-1.75276-.45652,3.586,3.586,0,0,1-1.88365-3.18423V539.52667a3.63311,3.63311,0,0,1,5.58117-3.06675l28.47118,15.00691a3.63334,3.63334,0,0,1,0,6.13349L777.1527,572.60723A3.616,3.616,0,0,1,775.20794,573.18123Z" transform="translate(-269.76401 -127.27589)" fill="#d70000"/><path d="M474.20509,401.72391l-55.30415.37144s-31.49717-10.154-45.78146-8.03242l-5.46159,21.45485,39.23459,12.99945L475.176,418.61a9.77391,9.77391,0,1,0-.97088-16.88606Z" transform="translate(-269.76401 -127.27589)" fill="#a0616a"/><path d="M406.42426,430.59478,340.8106,411.72391l-5.97349-22.25765a17.9737,17.9737,0,0,1,1.38938-18.92117h0c5.60148-7.58646,9.97993-.05089,17.92945,5.02222,13.93572.9852,48.71956,12.88719,62.83954,26.66818l-1.11256,8.47126Z" transform="translate(-269.76401 -127.27589)" fill="#3f3d56"/><path d="M463.51246,412.427a8.6945,8.6945,0,0,1-4.19433-1.09245,8.58134,8.58134,0,0,1-4.50753-7.61979V331.89236a8.69394,8.69394,0,0,1,13.35561-7.33865l68.13087,35.91118a8.69448,8.69448,0,0,1,0,14.6773l-68.13087,35.91119A8.65291,8.65291,0,0,1,463.51246,412.427Z" transform="translate(-269.76401 -127.27589)" fill="#d70000"/><polygon points="147.978 631.089 161.937 631.088 168.577 577.248 147.976 577.249 147.978 631.089" fill="#a0616a"/><path d="M414.1815,753.8071l3.9289-.00014,15.33912-6.238,8.2213,6.23709h.00112a17.51926,17.51926,0,0,1,17.51834,17.51809v.56928l-45.00793.00169Z" transform="translate(-269.76401 -127.27589)" fill="#2f2e41"/><polygon points="48.578 617.948 61.8 622.424 85.358 573.559 65.845 566.952 48.578 617.948" fill="#a0616a"/><path d="M316.4313,739.765l3.72137,1.26,16.52951-.98859,5.78645,8.54447.00106.00036a17.51925,17.51925,0,0,1,10.974,22.2114l-.18259.5392-42.63058-14.43425Z" transform="translate(-269.76401 -127.27589)" fill="#2f2e41"/><path d="M334.52184,526.45675s-1.62991,19.55885,2.44485,38.30275,12.84391,80.96441,12.84391,80.96441c-17.76168,29.19372-28.05554,57.92114-30,87l25,2,35.79645-84.93431,3.62687-85.03007,26.07847,57.86161-1.341,4.47013a5.03633,5.03633,0,0,0,2.15278,5.71677h0s-2.44165,15.89157-.81175,15.89157,5.70466,2.44483,5.70466,2.44483c-10.15972,31.628-11.52362,61.91681-2.20645,90.57947l22-1,14.43445-124.62239-10.59438-67.641-.815-13.03923-3.66728.15076-1.86735-5.44795-3.42984-9.37195Z" transform="translate(-269.76401 -127.27589)" fill="#2f2e41"/><path d="M333.1132,530.56494l-.14524-.20374c-7.75717-10.86019,3.90962-36.957,5.66925-40.74005l-7.41137-2.40507-6.48062-54.84015L320.00555,413.431a41.5924,41.5924,0,0,1,11.80527-40.3079l10.95569-10.32976,13.3146-19.70086H377.5524l7.362,13.90592a31.29509,31.29509,0,0,1,24.2138,31.95183l-1.66851,36.4711,6.532,45.40971.004,8.218,11.34007,18.59269,2.47033,11.52711c1.02227,1.349,7.7699,10.34608,7.7699,12.80566,0,.36927-.27258.72621-.85753,1.1222-4.59844,3.11377-30.01476,9.46188-41.26372,4.96054-11.98235-4.791-59.61408,2.39631-60.094,2.46953Z" transform="translate(-269.76401 -127.27589)" fill="#3f3d56"/><path d="M552.43409,771.53411a1.18645,1.18645,0,0,1-1.18293,1.19H270.954a1.19,1.19,0,0,1,0-2.38h280.29a1.18652,1.18652,0,0,1,1.19007,1.18292Z" transform="translate(-269.76401 -127.27589)" fill="#ccc"/><circle cx="99.82636" cy="181.02093" r="28.43602" fill="#a0616a"/><path d="M475.15,330.12845l-43.87271,33.673s-31.24241,10.91269-41.35163,21.22509l8.59349,20.40322,39.12915-13.31349,48.46682-49.10964A9.77391,9.77391,0,1,0,475.15,330.12845Z" transform="translate(-269.76401 -127.27589)" fill="#a0616a"/><path d="M438.5288,394.0554,377.582,411.90153l-20.955-7.43619A17.97374,17.97374,0,0,1,346.3156,388.54h0c-.11217-9.42965,7.92682-6.06361,17.32708-6.8162,11.70626-7.62485,46.62425-19.12731,66.19987-16.66062l4.22542,7.426Z" transform="translate(-269.76401 -127.27589)" fill="#3f3d56"/><path d="M389.08925,275.46532c-2.038-.06055-1.3384-3.90205-2.98036-5.1275q-.012.05576-.02486.11131a4.00215,4.00215,0,0,1-7.64816.3263,6.08259,6.08259,0,0,0-3.862-4.05152c-.10225,3.56059-2.79555,6.65085-6.0086,8.18873s-6.87661,1.79378-10.43833,1.84647c-3.56173.05261-7.17472-.06664-10.6286.805-3.45381.87154-6.8133,2.92074-8.28893,6.16282-1.4757,3.24209-.42281,7.70573,2.80391,9.21465-2.49971.01331-4.62078,2.076-5.4851,4.42158a17.557,17.557,0,0,0-.542,7.41887c.70252,9.19517,2.4153,19.09484,9.11091,25.43626,5.103,4.83306,12.40716,6.78,19.43551,6.7519,7.02835-.02818,5.79255-.67419,12.58822-2.46805,0,0,6.4608-18.52155,4.83392-20.34359-1.62689-1.822-2.97818-4.15349-2.68374-6.57835s2.90035-4.597,5.16184-3.674c-.38026-.97209-.66676-1.15726-.84619-1.10791a8.59452,8.59452,0,0,0,.29882-.845,9.616,9.616,0,0,1,6.00541-6.36826,7.4573,7.4573,0,0,1,8.15078,2.46671C405.48293,291.073,400.8664,275.81505,389.08925,275.46532Z" transform="translate(-269.76401 -127.27589)" fill="#2f2e41"/><path d="M870.43164,161.76008h-454.293a1.807,1.807,0,0,1,0-3.61318h454.293a1.807,1.807,0,0,1,0,3.61318Z" transform="translate(-269.76401 -127.27589)" fill="#cacaca"/><ellipse cx="177.29893" cy="10.82345" rx="10.58751" ry="10.82345" fill="#3f3d56"/><ellipse cx="213.87395" cy="10.82345" rx="10.58751" ry="10.82345" fill="#3f3d56"/><ellipse cx="250.44897" cy="10.82345" rx="10.58751" ry="10.82345" fill="#3f3d56"/><path d="M848.41038,129.95859h-25.981a1.96761,1.96761,0,0,0,0,3.93445h25.981a1.96761,1.96761,0,0,0,0-3.93445Z" transform="translate(-269.76401 -127.27589)" fill="#3f3d56"/><path d="M848.41038,137.343h-25.981a1.96761,1.96761,0,0,0,0,3.93445h25.981a1.96761,1.96761,0,0,0,0-3.93445Z" transform="translate(-269.76401 -127.27589)" fill="#3f3d56"/><path d="M848.41038,144.71763h-25.981a1.96761,1.96761,0,0,0,0,3.93445h25.981a1.96761,1.96761,0,0,0,0-3.93445Z" transform="translate(-269.76401 -127.27589)" fill="#3f3d56"/><path d="M628.8393,263.29909v27.16c0,1.35-2.36,2.48-5.54,2.79a.22024.22024,0,0,0-.08.01c-.53.04-1.09.07-1.66.07a14.57028,14.57028,0,0,1-5.15-.84c-.15-.06-.3-.13-.45-.19-.14-.08-.29-.15-.43-.23-.79-.47-1.25-1.02-1.25-1.61v-27.16Z" transform="translate(-269.76401 -127.27589)" fill="#ccc"/><circle cx="580.09962" cy="457.78558" r="12.37235" fill="#3f3d56"/><path d="M848.93732,590.00617c-.02637,0-.05275-.00086-.07912-.00215a1.61793,1.61793,0,0,1-1.19937-.62316l-2.06763-2.6582a1.6186,1.6186,0,0,1,.2837-2.27179l.07441-.05789a1.61842,1.61842,0,0,1,2.27221.28391,1.18065,1.18065,0,0,0,1.788.08707l4.1981-4.43206a1.621,1.621,0,0,1,2.28872-.06218l.06883.06561a1.61841,1.61841,0,0,1,.06176,2.28851l-6.51491,6.87668A1.61694,1.61694,0,0,1,848.93732,590.00617Z" transform="translate(-269.76401 -127.27589)" fill="#fff"/><circle cx="648.09962" cy="227.78558" r="12.37235" fill="#3f3d56"/><path d="M916.93732,360.00617c-.02637,0-.05275-.00086-.07912-.00215a1.61793,1.61793,0,0,1-1.19937-.62316l-2.06763-2.6582a1.6186,1.6186,0,0,1,.2837-2.27179l.07441-.05789a1.61842,1.61842,0,0,1,2.27221.28391,1.18065,1.18065,0,0,0,1.788.08707l4.1981-4.43206a1.621,1.621,0,0,1,2.28872-.06218l.06883.06561a1.61841,1.61841,0,0,1,.06176,2.28851l-6.51491,6.87668A1.61694,1.61694,0,0,1,916.93732,360.00617Z" transform="translate(-269.76401 -127.27589)" fill="#fff"/></svg>
                </div>

                <div class="leading-loose w-full text-center">
                  <p>If you would like to create a private location, please speak to our team</p>
                </div>

                <div class="text-center w-full">
                  <el-button
                      @click="() => { show_add_location = false; openSupport()   }"
                      type="success">
                    <div class="flex items-center gap-x-2 justify-center">
                      <div>
                        <svg xmlns="http://www.w3.org/2000/svg"
                             class="w-5 h-5 text-white"
                             fill="currentColor"
                             viewBox="0 0 24 24"><path d="M12 1c-6.338 0-12 4.226-12 10.007 0 2.05.738 4.063 2.047 5.625.055 1.83-1.023 4.456-1.993 6.368 2.602-.47 6.301-1.508 7.978-2.536 9.236 2.247 15.968-3.405 15.968-9.457 0-5.812-5.701-10.007-12-10.007zm0 15c-.565 0-1.024-.459-1.024-1.025 0-.565.459-1.024 1.024-1.024.566 0 1.024.459 1.024 1.024 0 .566-.458 1.025-1.024 1.025zm1.606-4.858c-.74.799-.775 1.241-.766 1.785h-1.643c-.006-1.208.016-1.742 1.173-2.842.469-.446.84-.799.788-1.493-.047-.66-.599-1.004-1.117-1.004-.581 0-1.261.432-1.261 1.649h-1.646c0-1.966 1.155-3.237 2.941-3.237.849 0 1.592.278 2.09.783.468.473.709 1.125.7 1.883-.013 1.134-.704 1.878-1.259 2.476z"/></svg>
                      </div>
                      <div>
                        Contact Support
                      </div>
                    </div>
                  </el-button>
                </div>

              </div>

            </template>
          </small-modal>

          <alert-confirm
              :show="confirm.subscription"
              @cancel="confirm.subscription = false"
              @confirm="() => { confirm.subscription = false; openSupport() }"
              :loading="false"
              confirm-text="Contact Support"
              cancel-text="Close"
              @close="()=> {  confirm.subscription = false }"
          >
            <template slot="title">
              Your subscription has expired
            </template>
            <template slot="message">
              Sorry, but it looks like your subscription to this private location has expired.
              Please contact support if you would like to renew.
            </template>
          </alert-confirm>
        </template>

      <template slot="nav-search">
        <div class="flex-grow"></div>
      </template>
      <template slot="nav-cta">
        <el-button
            @click="() => show_add_location = true"
            icon="el-icon-plus" type="success">
          Add Private Location
        </el-button>
      </template>

        <template slot="content">

            <div v-if="fetching">
                <spin-loader bg="transparent" height="h-64"/>
            </div>
            <div v-else>
                <div v-if="items.length > 0">
                    <div class="sm:flex sm:items-center mb-3">
                        <div class="sm:flex-auto text-gray-500 overflow-hidden truncate">
                            {{ items.length }} Private location{{ items.length > 1 ? 's' : '' }}
                        </div>
                    </div>

                    <ul class="el--playlist">
                        <li
                                class="group relative block select-none hover:bg-gray-100 bg-white"
                                @click="openPrivateLocation(o)"
                                :key="x" v-for="(o, x) of items">
                            <div class="flex items-center">
                                <div
                                        :class="{
                                                        'border-t rounded-t': x === 0,
                                                        'rounded-b': x === items.length - 1
                                                        }"
                                        class="min-w-0 flex-1 flex items-center border-b border-r border-l  border-gray-200  hover:cursor-pointer px-4 py-6">
                                    <div class="min-w-0 flex-1 px-4 grid grid-cols-2 items-center md:grid-cols-4 gap-2">
                                        <div>
                                            <p class="font-medium text-red-700 text truncate">
                                                {{ o.name }}
                                            </p>
                                            <p class="truncate text-xs mt-2">
                                            <span class="mr-2">

                                            <span class="text-green-500" v-if="o.active">
                                              <i class="el-icon-check"></i>
                                            Subscription till {{ o.subscription_to | date }}
                                            </span>

                                                   <span class="text-red-500" v-if="!o.active">
                                              <i class="el-icon-close"></i>
                                            Subscription expired {{ o.subscription_to | date }}
                                            </span>

                                            </span>

                                            </p>
                                        </div>
                                        <div
                                            @click="openPrivateLocation(o)"
                                             class="mx-3 text-center flex justify-center items-center text-gray-700">
                                            <p class="text-sm truncate">
                                                {{ o.duration_secs | duration }}
                                            </p>
                                        </div>
                                      <div class="mx-3 flex justify-center text-sm text-gray-800 align-top">
                                        {{ o.items && o.items.length > 0  ? o.items.length : 0 }} media items
                                      </div>
                                        <div class="text-left flex justify-center items-center hidden md:block">
                                            <div v-if="o.items && o.items.length > 0"
                                                 class="flex overflow-hidden -space-x-2">
                                                <div :key="i" v-for="(x, i) of o.items">

                                                    <img
                                                            v-if="x.screenshot_src"
                                                            class="h-8 w-8 rounded border shadow-lg"
                                                            :style="{
                                                        'border-color': x.bg_color ? x.bg_color : '#000000',
                                                        }"
                                                            :src="x.screenshot_src"/>

                                                    <div v-else
                                                         :style="{
                                                        'border-color': x.bg_color ? x.bg_color : '#000000',
                                                        }"
                                                         class="text-xl text-center w-8 h-8 flex justify-center items-center rounded border bg-white shadow-lg">
                                                        <i
                                                                v-if="x.type === 'video' && !x.screenshot_src"
                                                                class="el-icon-video-camera text-gray-500"></i>
                                                        <i
                                                                v-if="x.type === 'image'  && !x.screenshot_src"
                                                                class="el-icon-picture text-gray-500"></i>
                                                    </div>
                                                </div>

                                            </div>
                                            <div v-else>
                                                <el-tag type="danger">No Media</el-tag>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="w-32 mx-2" v-if="o.active">
                                        <div class="hidden group-hover:block">
                                          <el-button type="info" icon="el-icon-view">
                                            Manage
                                          </el-button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>

                <div class v-else>
                    <div class="py-20">
                        <empty-state
                            description="You currently have no private locations"
                        />

                    </div>
                </div>

            </div>

        </template>
    </page-wrapper>
</template>

<script>

import AlertConfirm from '@/components/AlertConfirm';
import SmallModal from '@/components/SmallModal';
import SpinLoader from '../../components/SpinLoader';
import EmptyState from '../../components/EmptyState';

export default {
  name: 'PrivateLocations',
  components: {
    SmallModal,
    AlertConfirm,
    EmptyState,
    SpinLoader,

  },
  mounted() {
    this.fetch();
  },
  data() {
    return {
      show_add_location: false,
      confirm: {
        subscription: false,
      },
      fetching: true,
      items: [],
    };
  },
  watch: {},
  computed: {
    hasSelectedItems() {
      return this.getSelectedItems.length > 0;
    },
  },
  methods: {
    openPrivateLocation({ id, active }) {
      const vm = this;
      if (active) {
        return vm.$router.push(`/private-locations/${id}`);
      }
      vm.confirm.subscription = true;
    },
    openSupport() {
      const el = document.querySelector('.woot-widget-bubble');
      if (el) {
        el.click();
      }
    },
    deletePlaylist() {
      const vm = this;
      vm.confirm.delete.loading = true;

      const requests = vm.confirm.delete.ids.map((id) => this.$http.delete(`/api/v1/playlist/${id}`));

      vm.$http.all(requests)
        .then(vm.$http.spread(() => {
          vm.fetch();
          vm.$notify({
            type: 'success',
            title: 'Playlists Deleted',
            message: 'Your playlists have been deleted successfully',
            position: 'bottom-left',
          });
          vm.confirm.delete.open = false;
          vm.confirm.delete.loading = false;
        })).catch(() => {
          vm.confirm.delete.open = false;
          vm.confirm.delete.loading = false;
          vm.fetch();
        });
    },
    confirmMultipleDelete() {
      const vm = this;
      vm.confirm.delete.ids = this.getSelectedItems.map((x) => x.id);
      vm.confirm.delete.open = true;
    },
    confirmDelete(id) {
      const vm = this;
      vm.confirm.delete.ids = [id];
      vm.confirm.delete.open = true;
    },
    fetch() {
      const vm = this;
      vm.fetching = true;
      const path = '/api/v1/private-locations';
      vm.$http.get(path)
        .then((response) => {
          vm.fetching = false;
          vm.items = response.data.data.map((x) => {
            x.selected = false;
            x.menu_open = false;
            return x;
          });
        }).catch(() => {
          vm.items = [];
          vm.fetching = false;
        });
    },
  },
};
</script>
<style>
    .el-dropdown {
        position: static;
    }
</style>
